import { Component } from '@angular/core';
import { CommonUtil } from "../../util/commonUtil";
import { AlertController, LoadingController, NavParams, ToastController, ViewController } from "ionic-angular";
import { LotteryService } from "../../services/lottery.services";
import { AppDialog } from "../../component/appDialog";
import { TranslateService } from 'ng2-translate';

@Component({
    templateUrl: 'betDetailsBauCua.html',
    selector: 'bet-details-baucua-page',
})
export class BetDetailsBauCuaPage {
    private id: any;
    private gameID: number;
    private betInfo: any;
    private is1Giay: boolean = false;
    public winnumberArr: any;
    type: string;

    constructor(private toastCtrl: ToastController,
        public translate: TranslateService,
         public params: NavParams, private lotteryService: LotteryService, private alertCtrl: AlertController, public loadingCtrl: LoadingController, public viewCtrl: ViewController) {
        const getDataParams = params['data'];
        this.id = getDataParams['betID'];
        this.gameID = getDataParams['gameID'];
        switch(this.gameID) {
            case 92:
                this.type = 'Bầu Cua';
                break;
            case 93:
                this.type = 'Bầu Cua';
                break;
            case 94:
                this.type = 'Oẳn Tù Tì';
                break;
            default:
                break;
        }
        this.gameID === 92 || this.gameID === 94 ? this.is1Giay = true : this.is1Giay = false;
        let dataParams = { id: this.id };
        this.getLotteryRecordInfo(dataParams);
    }

    getLotteryRecordInfo(dataParams: any) {
        this.lotteryService.lotteryRecordBeanInfo(dataParams, this).then(data => {
            if (data["msg"] === '') {
                this.betInfo = data["betinfo"];
                this.betInfo['codes'] = this.betInfo['codes'].replace(/[&]/g, ',');
                this.betInfo["inserttime"] = this.betInfo["inserttime"].replace(/-/g, '/');
                if (this.is1Giay) this.betInfo["issue"] = this.betInfo["inserttime"].substr(11);
                if (this.gameID !== 94) {
                    this.betInfo["codes"] = this.betInfo["codes"].replace(/&&/g, " ").replace(/@/g, "\r\n");
                    let arr = Array.from(this.betInfo.winnumber);
                    this.winnumberArr = arr.filter((item) => item != '|').map(itemWinNum => {
                        if (Number(itemWinNum) === 1) {
                            itemWinNum = 'nai';
                        } else if (Number(itemWinNum) === 2) {
                            itemWinNum = 'cua';
                        } else if (Number(itemWinNum) === 3) {
                            itemWinNum = 'ga';
                        } else if (Number(itemWinNum) === 4) {
                            itemWinNum = 'ca';
                        } else if (Number(itemWinNum) === 5) {
                            itemWinNum = 'bau';
                        } else if (Number(itemWinNum) === 6) {
                            itemWinNum = 'tom';
                        }
                        return itemWinNum
                    });
                    this.betInfo["codes"] = this.betInfo["codes"].toLowerCase().replace(/\b]bet/g, '').replace(/[\[]/g, '')
                        .replace(/prize/g, "Thắng")
                        .replace("nai", "Nai")
                        .replace("cua", "Cua")
                        .replace("ga", "Gà")
                        .replace("ca", "Cá")
                        .replace("bau", "Bầu")
                        .replace("tom", "Tôm");
                    this.betInfo["codes"] = this.betInfo["codes"].split(',,');
                } else {
                    this.winnumberArr = this.betInfo.winnumber.split('|');
                    this.betInfo["codes"] = this.betInfo["codes"].replace(/&&/g, " ").replace(/@/g, "\r\n");
                    this.betInfo["codes"] = this.betInfo["codes"].toLowerCase().replace(/\b]bet/g, '').replace(/[\[]/g, '')
                        .replace(/prize/g, "Thắng")
                        .replace("rock_right", "Búa phải")
                        .replace("paper_right", "Bao phải")
                        .replace("sciss_right", "Kéo phải")
                        .replace("rock_left", "Búa trái")
                        .replace("paper_left", "Bao trái")
                        .replace("sciss_left", "Kéo trái")
                        .replace("draw", "Hòa")
                        .replace("left_win", "Trái Thắng")
                        .replace("right_win", "Phải Thắng")
                    this.betInfo["codes"] = this.betInfo["codes"].split(',,');
                }
            }
        });
    }

    copy(url: string) {
        CommonUtil.copyToClipboard(url, this.toastCtrl);
    }

    cancelBet() {
        let dataParams = { id: this.id };
        this.lotteryService.lotteryCancelBet(dataParams, this.alertCtrl).then(data => {
            if (data["msg"] === '') {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: this.translate.instant('CANCEL_BET_SUCCESS')
                });
                this.viewCtrl.dismiss().catch(() => { });
            } else {
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: data["msg"]
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/betDetailsBauCua/betDetailsBauCua.ts